module.exports = __webpack_public_path__ + "static/media/IMG_7901.a0cce6f3.JPG";